import SliderSkeleton from '../BrandSection/Slider/SliderSkeleton';
import './HistorySkeleton.scss';


const HistorySkeleton = () => {

  return (
    <div className='about__history__section__wrapper__skeleton'>
      <div className='about__history__left__section__skeleton'>
        <div className='about__history__left__section__title__skeleton'></div>
        {[4, 1, 3, 1, 4, 1, 3, 1].map((count, index) =>
          [...Array(count)].map((_, i) => (
            <div
              key={`${index}-${i}`}
              className={`about__history__left__section__text__skeleton${index % 2 === 1 ? '--primary' : ''}`}
            ></div>
          ))
        )}
      </div>
      <div className='about__history__right__section__skeleton'>
        <div className='clients__title__skeleton'></div>
        <SliderSkeleton />
      </div>
    </div>
  );
};

export default HistorySkeleton;